const getColor = (key) =>
  getComputedStyle(document.documentElement)
    .getPropertyValue(`--${key}`)
    ?.trim();

const themeColors = {
  primary050: getColor("primary-050"),
  primary100: getColor("primary-100"),
  primary150: getColor("primary-150"),
  primary180: getColor("primary-180"),
  primary200: getColor("primary-200"),
  primary230: getColor("primary-230"),
  primary250: getColor("primary-250"),
  primary290: getColor("primary-290"),
  primary300: getColor("primary-300"),
  primary350: getColor("primary-350"),
  primary400: getColor("primary-400"),
  primary500: getColor("primary-500"),
  primary600: getColor("primary-600"),
  primary850: getColor("primary-850"),
  primary900: getColor("primary-900"),
  primary950: getColor("primary-950"),

  secondary100: getColor("secondary-100"),
  secondary120: getColor("secondary-120"),
  secondary150: getColor("secondary-150"),
  secondary200: getColor("secondary-200"),
  secondary300: getColor("secondary-300"),
  secondary500: getColor("secondary-500"),
  secondary600: getColor("secondary-600"),

  accenta400: getColor("accent-a-400"),
  accenta500: getColor("accent-a-500"),
  accentb500: getColor("accent-b-500"),
  accentc500: getColor("accent-c-500"),
  accentd500: getColor("accent-d-500"),
  accente400: getColor("accent-e-400"),
  accente500: getColor("accent-e-500"),
  accente550: getColor("accent-e-550"),
  accente600: getColor("accent-e-600"),
  accente700: getColor("accent-e-700"),
  accentf100: getColor("accent-f-100"),
  accentf500: getColor("accent-f-500"),
  accentf600: getColor("accent-f-600"),
  accentf700: getColor("accent-f-700"),
  accentg500: getColor("accent-g-500"),

  neutral000: getColor("neutral-000"),
  neutral050: getColor("neutral-050"),
  neutral090: getColor("neutral-090"),
  neutral095: getColor("neutral-095"),
  neutral100: getColor("neutral-100"),
  neutral105: getColor("neutral-105"),
  neutral120: getColor("neutral-120"),
  neutral150: getColor("neutral-150"),
  neutral190: getColor("neutral-190"),
  neutral195: getColor("neutral-195"),
  neutral198: getColor("neutral-198"),
  neutral200: getColor("neutral-200"),
  neutral250: getColor("neutral-250"),
  neutral275: getColor("neutral-275"),
  neutral280: getColor("neutral-280"),
  neutral290: getColor("neutral-290"),
  neutral300: getColor("neutral-300"),
  neutral350: getColor("neutral-350"),
  neutral400: getColor("neutral-400"),
  neutral430: getColor("neutral-430"),
  neutral450: getColor("neutral-450"),
  neutral460: getColor("neutral-460"),
  neutral480: getColor("neutral-480"),
  neutral500: getColor("neutral-500"),
  neutral550: getColor("neutral-550"),
  neutral600: getColor("neutral-600"),
  neutral620: getColor("neutral-620"),
  neutral650: getColor("neutral-650"),
  neutral680: getColor("neutral-680"),
  neutral700: getColor("neutral-700"),
  neutral750: getColor("neutral-750"),
  neutral780: getColor("neutral-780"),
  neutral790: getColor("neutral-790"),
  neutral800: getColor("neutral-800"),
  neutral850: getColor("neutral-850"),
  neutral870: getColor("neutral-870"),
  neutral890: getColor("neutral-890"),
  neutral900: getColor("neutral-900"),
  neutral950: getColor("neutral-950"),
  neutral1000: getColor("neutral-1000"),

  stateerror100: getColor("state-error-100"),
  stateerror500: getColor("state-error-500"),
  statesuccess500: getColor("state-success-500"),
  stateinfo500: getColor("state-info-500"),
};

module.exports = { themeColors };
